<template>
  <div class="site-type">
    <div class="site-typpe-inner">
      <a-table size="middle" rowKey="spiderClassId" :columns="columns" :data-source="tableData">
        <div class="title-solt-container" slot="title">
          <a-button type="primary" @click="handleAdd">
            <a-icon type="plus" />
            新增</a-button
          >
        </div>

        <span slot="action" slot-scope="text, record">
          <a-button @click="handleEdit(record)" type="link">修改 </a-button>
          <a-divider type="vertical" />
          <a-popconfirm title="确定要删除吗?" @confirm="() => handleDelete(record)">
            <a-button type="link">删除 </a-button>
          </a-popconfirm>
        </span>
      </a-table>
      <a-modal
        :title="formModel ? '修改分类' : '新增分类'"
        @cancel="handleCancel"
        :footer="null"
        :visible="visible"
      >
        <Form :formModel="formModel" @onClose="handleCancel" @onSubmitSuccess="handleCloseModal" />
      </a-modal>
    </div>
  </div>
</template>

<script>
import Form from './Form'
import { querySpiderClassInfoApi, deleteSpiderClassItemApi } from '@/api/Site/Type'
export default {
  data() {
    return {
      tableData: [],
      columns: [
        {
          title: '分类名称',
          dataIndex: 'spiderClassName'
        },
        {
          title: '分类类别',
          dataIndex: 'type'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 120,
          align: 'center'
        }
      ],
      formModel: null,
      visible: false
    }
  },
  created() {
    this.querySpiderClassInfoApi()
  },
  methods: {
    handleAdd() {
      this.visible = true
      this.formModel = null
    },
    handleCloseModal() {
      this.visible = false
      this.querySpiderClassInfoApi()
    },

    handleCancel() {
      this.visible = false
    },
    handleEdit(val) {
      this.visible = true
      this.formModel = val
    },
    async querySpiderClassInfoApi() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.tableData = data
      } else {
        this.$message.error(msg)
      }
    },
    async handleDelete({ spiderClassId }) {
      let res = await deleteSpiderClassItemApi({
        spiderClassId
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.querySpiderClassInfoApi()
      } else {
        this.$message.error(msg)
      }
    }
  },
  components: {
    Form
  }
}
</script>

<style lang="less" scoped>
.site-type {
  padding: 16px;

  .site-typpe-inner {
    padding: 0 16px;
    width: 100%;
    background: white;

    .title-solt-container {
      display: flex;
      flex-direction: row-reverse;
    }
  }
}
</style>
